// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-periodos {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
}

.container-periodos button {
    margin: 10px;
}


.container-periodos a, span{
margin: 5px;
    color: var(--aiAzul);
}

.container-periodos a:hover{
    color: var(--aiLaranja);
    cursor: pointer;

}


`, "",{"version":3,"sources":["webpack://./src/components/historico-periodos/card-style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;;AAGA;AACA,WAAW;IACP,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,eAAe;;AAEnB","sourcesContent":[".container-periodos {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.container-periodos button {\n    margin: 10px;\n}\n\n\n.container-periodos a, span{\nmargin: 5px;\n    color: var(--aiAzul);\n}\n\n.container-periodos a:hover{\n    color: var(--aiLaranja);\n    cursor: pointer;\n\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
